/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import AuthRequired from '@/utils/auth-required'
import {checkServerVersion, isExternalUser, scheduleVersionReload} from "@/utils";

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {x: 0, y: 0}
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      redirect: '/',
      beforeEnter: AuthRequired,
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        // {
        //   path: '/',
        //   name: 'home',
        //   beforeEnter: ( to, from, next ) => {
        //     isExternalUser() ? next('/sale') : next();
        //   },
        //   component: () => import('./views/pages/Home/index.vue'),
        // },
        // {
        //   path: '/sale',
        //   name: 'sale',
        //   component: () => import('./views/pages/Home/_Sale/index.vue')
        // },
        // {
        //   path: '/dashboard/list/:loanType/:action',
        //   name: 'dashboard-list',
        //   component: () => import('./views/pages/Home/list.vue'),
        //   meta: {
        //     breadcrumb: [
        //       { title: 'Home', url: '/' },
        //       { title: { i18n: 'sections.home.title', default: 'Home' } },
        //       { title: { i18n: 'sections.home.list.title', default: 'List' }, url: '/borrower', active: true },
        //     ],
        //     pageTitle: { i18n: 'sections.home.list.title', default: 'List' }
        //   }
        // },
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'dashboard',
          beforeEnter: (to, from, next) => {
            isExternalUser() ? next('/dashboard/sale') : next();
          },
          component: () => import('./views/pages/Dashboard/index.vue'),
        },
        {
          path: '/dashboard/list/:action',
          name: 'dashboard-list',
          component: () => import('./views/pages/Dashboard/List/index.vue')
        },
        {
          path: '/dashboard/list/:action/:id',
          name: 'dashboard-list-with-id',
          component: () => import('./views/pages/Dashboard/List/index.vue')
        },
        {
          path: '/dashboard/sale',
          name: 'dashboard-sale',
          component: () => import('./views/pages/Dashboard/Sale/index.vue')
        },
        {
          path: '/sample-messages',
          name: 'sample-messages',
          component: () => import('./views/pages/SampleMessage/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: 'ตัวอย่างข้อความ', active: true}
            ],
            pageTitle: 'ตัวอย่างข้อความ'
          }
        },
        // =============================================================================
        // Theme Customer
        // =============================================================================
        {
          path: '/customer/borrower',
          name: 'customer-borrower',
          component: () => import('./views/pages/Customer/Borrower/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.customer.title', default: 'Customer'}},
              {
                title: {i18n: 'sections.customer.borrower.title', default: 'Borrower'},
                url: '/customer/borrower',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.customer.borrower.title', default: 'Borrower'}
          }
        },
        {
          path: '/customer/borrowerSearch/:id',
          name: 'customer-borrower-search',
          component: () => import('./views/pages/Customer/Borrower/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.customer.title', default: 'Customer'}},
              {
                title: {i18n: 'sections.customer.borrower.title', default: 'Borrower'},
                url: '/customer/borrower',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.customer.borrower.title', default: 'Borrower'}
          }
        },
        {
          path: '/customer/borrower/list',
          name: 'customer-borrower-list',
          component: () => import('./views/pages/Customer/Borrower/list.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.customer.title', default: 'Customer'}},
              {
                title: {i18n: 'sections.customer.borrower.title', default: 'Borrower'},
                url: '/customer/borrower',
                active: true
              },
              {
                title: {i18n: 'sections.customer.borrower.list.title', default: 'List'},
                url: '/customer/borrower/list',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.customer.borrower.list.title', default: 'List'}
          }
        },
        {
          path: '/customer/borrower/add',
          name: 'customer-borrower-add',
          component: () => import('./views/pages/Customer/Borrower/add.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.customer.title', default: 'Customer'}},
              {
                title: {i18n: 'sections.customer.borrower.title', default: 'Borrower'},
                url: '/customer/borrower',
                active: true
              },
              {
                title: {i18n: 'sections.customer.borrower.add.title', default: 'Add'},
                url: '/customer/borrower/add',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.customer.borrower.add.title', default: 'Add'}
          }
        },
        {
          path: '/customer/borrower/view/:id',
          name: 'customer-borrower-view',
          component: () => import('./views/pages/Customer/Borrower/view.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.customer.title', default: 'Customer'}},
              {
                title: {i18n: 'sections.customer.borrower.title', default: 'Borrower'},
                url: '/customer/borrower',
                active: true
              },
              {
                title: {i18n: 'sections.customer.borrower.view.title', default: 'View'},
                url: '/customer/borrower/view/:id',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.customer.borrower.view.title', default: 'View'}
          }
        },
        {
          path: '/customer/borrower/edit/:id',
          name: 'customer-borrower-edit',
          component: () => import('./views/pages/Customer/Borrower/edit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.customer.title', default: 'Customer'}},
              {
                title: {i18n: 'sections.customer.borrower.title', default: 'Borrower'},
                url: '/customer/borrower',
                active: true
              },
              {
                title: {i18n: 'sections.customer.borrower.edit.title', default: 'Edit'},
                url: '/customer/borrower/edit/:id',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.customer.borrower.edit.title', default: 'Edit'}
          }
        },
        {
          path: '/customer/surety',
          name: 'customer-surety',
          component: () => import('./views/pages/Customer/Surety/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.customer.title', default: 'Customer'}},
              {
                title: {i18n: 'sections.customer.surety.title', default: 'Surety'},
                url: '/customer/surety',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.customer.surety.title', default: 'Surety'}
          }
        },
        {
          path: '/customer/surety/list',
          name: 'customer-surety-list',
          component: () => import('./views/pages/Customer/Borrower/list.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.customer.title', default: 'Customer'}},
              {
                title: {i18n: 'sections.customer.surety.title', default: 'Borrower'},
                url: '/customer/surety',
                active: true
              },
              {
                title: {i18n: 'sections.customer.surety.list.title', default: 'List'},
                url: '/customer/surety/list',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.customer.surety.list.title', default: 'List'}
          }
        },
        {
          path: '/customer/surety/add',
          name: 'customer-surety-add',
          component: () => import('./views/pages/Customer/Surety/add.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.customer.title', default: 'Customer'}},
              {
                title: {i18n: 'sections.customer.surety.title', default: 'Surety'},
                url: '/customer/surety',
                active: true
              },
              {
                title: {i18n: 'sections.customer.surety.add.title', default: 'Add'},
                url: '/customer/surety/add',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.customer.surety.add.title', default: 'Add'}
          }
        },
        {
          path: '/customer/surety/view/:id',
          name: 'customer-surety-view',
          component: () => import('./views/pages/Customer/Surety/view.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.customer.title', default: 'Customer'}},
              {
                title: {i18n: 'sections.customer.surety.title', default: 'Surety'},
                url: '/customer/surety',
                active: true
              },
              {
                title: {i18n: 'sections.customer.surety.view.title', default: 'View'},
                url: '/customer/surety/view/:id',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.customer.surety.view.title', default: 'View'}
          }
        },
        {
          path: '/customer/surety/edit/:id',
          name: 'customer-surety-edit',
          component: () => import('./views/pages/Customer/Surety/edit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.customer.title', default: 'Customer'}},
              {
                title: {i18n: 'sections.customer.surety.title', default: 'Surety'},
                url: '/customer/surety',
                active: true
              },
              {
                title: {i18n: 'sections.customer.surety.edit.title', default: 'Edit'},
                url: '/customer/surety/edit/:id',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.customer.surety.edit.title', default: 'Edit'}
          }
        },
        {
          path: '/customer/import',
          name: 'customer-import',
          component: () => import('./views/pages/Customer/Import/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.customer.title', default: 'Customer'}},
              {
                title: {i18n: 'sections.customer.import.title', default: 'Import'},
                url: '/customer/import',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.customer.import.title', default: 'Import'}
          }
        },
        // =============================================================================
        // Theme Loan
        // =============================================================================
        {
          path: '/accounting/contract',
          name: 'accounting-contract',
          component: () => import('./views/pages/Accounting/Contract/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.accounting.title', default: 'Accounting'}},
              {
                title: {i18n: 'sections.accounting.contract.title', default: 'Contract'},
                url: '/accounting/contract',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.accounting.contract.title', default: 'Contract'}
          }
        },
        {
          path: '/accounting/contract/detail/:id',
          name: 'accounting-contract-detail',
          component: () => import('./views/pages/Accounting/Contract/Detail/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.accounting.title', default: 'Accounting'}},
              {
                title: {i18n: 'sections.accounting.contract.title', default: 'Contract'},
                url: '/accounting/contract',
                active: true
              },
              {
                title: {i18n: 'sections.accounting.contract.detail.title', default: 'Detail'},
                url: '/accounting/contract/detail',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.accounting.contract.detail.title', default: 'Detail'}
          }
        },
        {
          path: '/accounting/contract/add',
          name: 'accounting-contract-add',
          component: () => import('./views/pages/Accounting/Contract/add.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.accounting.title', default: 'Accounting'}},
              {
                title: {i18n: 'sections.accounting.contract.title', default: 'Contract'},
                url: '/accounting/contract',
                active: true
              },
              {
                title: {i18n: 'sections.accounting.contract.add.title', default: 'Add'},
                url: '/accounting/contract/add',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.accounting.contract.add.title', default: 'Add'}
          }
        },
        {
          path: '/accounting/contract/edit/:id',
          name: 'accounting-contract-edit',
          component: () => import('./views/pages/Accounting/Contract/edit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.accounting.title', default: 'Accounting'}},
              {
                title: {i18n: 'sections.accounting.contract.title', default: 'Contract'},
                url: '/accounting/contract',
                active: true
              },
              {
                title: {i18n: 'sections.accounting.contract.edit.title', default: 'Edit'},
                url: '/accounting/contract/edit',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.accounting.contract.edit.title', default: 'Edit'}
          }
        },
        {
          path: '/accounting/contract/nplReturn/:id',
          name: 'accounting-contract-nplReturn',
          component: () => import('./views/pages/Accounting/Contract/edit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.accounting.title', default: 'Accounting'}},
              {
                title: {i18n: 'sections.accounting.contract.title', default: 'Contract'},
                url: '/accounting/contract',
                active: true
              },
              {
                title: {i18n: 'sections.accounting.contract.edit.title', default: 'Edit'},
                url: '/accounting/contract/edit',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.accounting.contract.edit.title', default: 'Edit'}
          }
        },
        {
          path: '/accounting/contract/print/:id',
          name: 'accounting-contract-print',
          component: () => import('./views/pages/Accounting/Contract/Print/'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.accounting.title', default: 'Accounting'}},
              {
                title: {i18n: 'sections.accounting.contract.title', default: 'Contract'},
                url: '/accounting/contract',
                active: true
              },
              {
                title: {i18n: 'sections.accounting.contract.print.title', default: 'Print'},
                url: '/accounting/contract/print',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.accounting.contract.print.title', default: 'Edit'}
          }
        },
        {
          path: '/accounting/contract/print/sale/:id',
          name: 'accounting-contract-print-sale',
          component: () => import('./views/pages/Accounting/Contract/Print/Sale'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.accounting.title', default: 'Accounting'}},
              {
                title: {i18n: 'sections.accounting.contract.title', default: 'Contract'},
                url: '/accounting/contract',
                active: true
              },
              {
                title: {i18n: 'sections.accounting.contract.print.title', default: 'Print'},
                url: '/accounting/contract/print',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.accounting.contract.print.title', default: 'Edit'}
          }
        },
        {
          path: '/accounting/transaction',
          name: 'accounting-transaction',
          component: () => import('./views/pages/Accounting/Transaction/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.accounting.title', default: 'Accounting'}},
              {
                title: {i18n: 'sections.accounting.transaction.title', default: 'Transaction'},
              }
            ],
            pageTitle: {i18n: 'sections.accounting.transaction.title', default: 'Transaction'}
          }
        },
        {
          path: '/accounting/transaction/filters/:contractNo',
          name: 'accounting-transaction-filters',
          component: () => import('./views/pages/Accounting/Transaction/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.accounting.title', default: 'Accounting'}},
              {
                title: {i18n: 'sections.accounting.transaction.title', default: 'Transaction'},
              }
            ],
            pageTitle: {i18n: 'sections.accounting.transaction.title', default: 'Transaction'}
          }
        },
        {
          path: '/accounting/transaction/manage/:id',
          name: 'accounting-transaction-manage',
          component: () => import('./views/pages/Accounting/Transaction/Manage/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.accounting.title', default: 'Accounting'}},
              {
                title: {i18n: 'sections.accounting.transaction.title', default: 'Transaction'},
              },
              {
                title: {i18n: 'sections.accounting.transaction.manage.title', default: 'Manage'},
                url: '/accounting/transaction/manage',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.accounting.transaction.manage.title', default: 'Manage'}
          }
        },
        {
          path: '/accounting/transaction/view/:id',
          name: 'accounting-transaction-view',
          component: () => import('./views/pages/Accounting/Transaction/View/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.accounting.title', default: 'Accounting'}},
              {
                title: {i18n: 'sections.accounting.transaction.title', default: 'Transaction'},
              },
              {
                title: {i18n: 'sections.accounting.transaction.view.title', default: 'View'},
                url: '/accounting/transaction/view',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.accounting.transaction.view.title', default: 'View'}
          }
        },
        {
          path: '/accounting/transactionEir/view/:id',
          name: 'accounting-transactionEir-view',
          component: () => import('./views/pages/Accounting/TransactionEir/View/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.accounting.title', default: 'Accounting'}},
              {
                title: {i18n: 'sections.accounting.transaction.title', default: 'Transaction'},
              },
              {
                title: {i18n: 'sections.accounting.transaction.view.title', default: 'View'},
                url: '/accounting/transaction/view',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.accounting.transaction.view.title', default: 'View'}
          }
        },
        {
          path: '/accounting/trackDownDebt',
          name: 'accounting-trackDownDebt',
          component: () => import('./views/pages/Accounting/TrackDownDebt/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.accounting.title', default: 'Accounting'}},
              {
                title: {i18n: 'sections.accounting.trackDownDebt.title', default: 'Transaction'},
                url: '/accounting/trackDownDebt',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.accounting.trackDownDebt.title', default: 'Transaction'}
          }
        },
        {
          path: '/accounting/trackDownDebt/filters/:contractNo',
          name: 'accounting-trackDownDebt-filters',
          component: () => import('./views/pages/Accounting/TrackDownDebt/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.accounting.title', default: 'Accounting'}},
              {
                title: {i18n: 'sections.accounting.trackDownDebt.title', default: 'Transaction'},
                url: '/accounting/trackDownDebt',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.accounting.trackDownDebt.title', default: 'Transaction'}
          }
        },
        {
          path: '/accounting/import',
          name: 'accounting-import',
          component: () => import('./views/pages/Accounting/Import/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.accounting.title', default: 'Accounting'}},
              {
                title: {i18n: 'sections.accounting.import.title', default: 'Import'},
                url: '/accounting/import',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.accounting.import.title', default: 'Import'}
          }
        },
        // =============================================================================
        // Theme Prosecution
        // =============================================================================
        {
          path: '/prosecution/lawyer',
          name: 'prosecution-lawyer',
          component: () => import('./views/pages/Prosecution/Lawyer/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.prosecution.title', default: 'Prosecution'}},
              {
                title: {i18n: 'sections.prosecution.lawyer.title', default: 'Lawyer'},
                url: '/prosecution/lawyer',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.prosecution.lawyer.title', default: 'Lawyer'}
          }
        },
        {
          path: '/prosecution/lawyer/add',
          name: 'prosecution-lawyer-add',
          component: () => import('./views/pages/Prosecution/Lawyer/add.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.prosecution.title', default: 'Prosecution'}},
              {
                title: {i18n: 'sections.prosecution.lawyer.title', default: 'Lawyer'},
                url: '/prosecution/lawyer',
                active: true
              },
              {
                title: {i18n: 'sections.prosecution.lawyer.add.title', default: 'Add'},
                url: '/prosecution/lawyer/add',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.prosecution.lawyer.add.title', default: 'Add'}
          }
        },
        {
          path: '/prosecution/lawyer/edit/:id',
          name: 'prosecution-lawyer-edit',
          component: () => import('./views/pages/Prosecution/Lawyer/edit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.prosecution.title', default: 'Prosecution'}},
              {
                title: {i18n: 'sections.prosecution.lawyer.title', default: 'Lawyer'},
                url: '/prosecution/lawyer',
                active: true
              },
              {
                title: {i18n: 'sections.prosecution.lawyer.edit.title', default: 'Edit'},
                url: '/prosecution/lawyer/edit/:id',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.prosecution.lawyer.edit.title', default: 'Edit'}
          }
        },
        {
          path: '/prosecution/userJob',
          name: 'prosecution-userJob',
          component: () => import('./views/pages/Prosecution/UserJob/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.prosecution.title', default: 'Prosecution'}},
              {
                title: {i18n: 'sections.prosecution.userJob.title', default: 'UserJob'},
                url: '/prosecution/userJob',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.prosecution.userJob.title', default: 'UserJob'}
          }
        },
        {
          path: '/prosecution/userJob/add',
          name: 'prosecution-userJob-add',
          component: () => import('./views/pages/Prosecution/UserJob/add.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.prosecution.title', default: 'Prosecution'}},
              {
                title: {i18n: 'sections.prosecution.userJob.title', default: 'UserJob'},
                url: '/prosecution/userJob',
                active: true
              },
              {
                title: {i18n: 'sections.prosecution.userJob.add.title', default: 'Add'},
                url: '/prosecution/userJob/add',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.prosecution.userJob.add.title', default: 'Add'}
          }
        },
        {
          path: '/prosecution/userJob/edit/:id',
          name: 'prosecution-userJob-edit',
          component: () => import('./views/pages/Prosecution/UserJob/edit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.prosecution.title', default: 'Prosecution'}},
              {
                title: {i18n: 'sections.prosecution.userJob.title', default: 'UserJob'},
                url: '/prosecution/userJob',
                active: true
              },
              {
                title: {i18n: 'sections.prosecution.userJob.edit.title', default: 'Edit'},
                url: '/prosecution/userJob/edit/:id',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.prosecution.userJob.edit.title', default: 'Edit'}
          }
        },
        {
          path: '/prosecution/lawyerJob',
          name: 'prosecution-lawyerJob',
          component: () => import('./views/pages/Prosecution/LawyerJob/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.prosecution.title', default: 'Prosecution'}},
              {
                title: {i18n: 'sections.prosecution.lawyerJob.title', default: 'LawyerJob'},
                url: '/prosecution/lawyerJob',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.prosecution.lawyerJob.title', default: 'LawyerJob'}
          }
        },
        {
          path: '/prosecution/lawyerJob/:action',
          name: 'prosecution-lawyerJob-action',
          component: () => import('./views/pages/Prosecution/LawyerJob/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.prosecution.title', default: 'Prosecution'}},
              {
                title: {i18n: 'sections.prosecution.lawyerJob.title', default: 'LawyerJob'},
                url: '/prosecution/lawyerJob',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.prosecution.lawyerJob.title', default: 'LawyerJob'}
          }
        },
        {
          path: '/prosecution/lawyerJob/edit/:id',
          name: 'prosecution-lawyerJob-edit',
          component: () => import('./views/pages/Prosecution/LawyerJob/edit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.prosecution.title', default: 'Prosecution'}},
              {
                title: {i18n: 'sections.prosecution.lawyerJob.title', default: 'LawyerJob'},
                url: '/prosecution/lawyerJob',
                active: true
              },
              {
                title: {i18n: 'sections.prosecution.lawyerJob.edit.title', default: 'Edit'},
                url: '/prosecution/lawyerJob/edit/:id',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.prosecution.lawyerJob.edit.title', default: 'Edit'}
          }
        },
        {
          path: '/prosecution/closeCancelHold',
          name: 'prosecution-closeCancelHold',
          component: () => import('./views/pages/Prosecution/CloseCancelHold/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.prosecution.title', default: 'Prosecution'}},
              {
                title: {i18n: 'sections.prosecution.closeCancelHold.title', default: 'CloseCancelHold'},
                url: '/prosecution/closeCancelHold',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.prosecution.closeCancelHold.title', default: 'CloseCancelHold'}
          }
        },
        {
          path: '/prosecution/closeCancelHold/:action',
          name: 'prosecution-closeCancelHold-action',
          component: () => import('./views/pages/Prosecution/CloseCancelHold/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.prosecution.title', default: 'Prosecution'}},
              {
                title: {i18n: 'sections.prosecution.closeCancelHold.title', default: 'CloseCancelHold'},
                url: '/prosecution/closeCancelHold',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.prosecution.closeCancelHold.title', default: 'CloseCancelHold'}
          }
        },
        {
          path: '/prosecution/transaction/detail/:contractId/:prosecutionId',
          name: 'prosecution-transaction-detail',
          component: () => import('./views/pages/Prosecution/Transaction/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.prosecution.title', default: 'Prosecution'}},
              {
                title: {i18n: 'sections.prosecution.transaction.title', default: 'Transaction'},
                url: '/prosecution/transaction',
                active: true
              },
            ],
            pageTitle: {i18n: 'sections.prosecution.transaction.title', default: 'View'}
          }
        },
        {
          path: '/prosecution/transaction/add/:contractId/:prosecutionId/:prosecutionType',
          name: 'prosecution-transaction-add',
          component: () => import('./views/pages/Prosecution/Transaction/add.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.prosecution.title', default: 'Prosecution'}},
              {
                title: {i18n: 'sections.prosecution.transaction.title', default: 'Transaction'},
                active: true
              },
              {
                title: {i18n: 'sections.prosecution.transaction.add.title', default: 'Add'},
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.prosecution.transaction.add.title', default: 'Add'}
          }
        },
        {
          path: '/prosecution/transaction/view/:contractId/:prosecutionId/:prosecutionDetailId/:prosecutionType',
          name: 'prosecution-transaction-view',
          component: () => import('./views/pages/Prosecution/Transaction/edit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.prosecution.title', default: 'Prosecution'}},
              {
                title: {i18n: 'sections.prosecution.transaction.title', default: 'Transaction'},
                active: true
              },
              {
                title: {i18n: 'sections.prosecution.transaction.view.title', default: 'View'},
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.prosecution.transaction.view.title', default: 'View'}
          }
        },
        // =============================================================================
        // Theme Report
        // =============================================================================
        {
          path: '/report/summary',
          name: 'report-summary',
          component: () => import('./views/pages/Report/Summary/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.report.title', default: 'report'}},
              {title: {i18n: 'sections.report.summary.title', default: 'Summary'}, url: '/report/summary', active: true}
            ],
            pageTitle: {i18n: 'sections.report.summary.title', default: 'Summary'}
          }
        },
        {
          path: '/report/summary-old',
          name: 'report-summary-old',
          component: () => import('./views/pages/Report/Backup/_Summary/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.report.title', default: 'report'}},
              {
                title: {i18n: 'sections.report.summary.title', default: 'Summary'},
                url: '/report/summary-old',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.report.summary.title', default: 'Summary'}
          }
        },
        {
          path: '/report/accounting',
          name: 'report-accounting',
          component: () => import('./views/pages/Report/Accounting/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.report.title', default: 'report'}},
              {
                title: {i18n: 'sections.report.accounting.title', default: 'Accounting'},
                url: '/report/accounting',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.report.accounting.title', default: 'Accounting'}
          }
        },
        {
          path: '/report/payin',
          name: 'report-payin',
          component: () => import('./views/pages/Report/Payin/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.report.title', default: 'report'}},
              {title: {i18n: 'sections.report.payin.title', default: 'Payin'}, url: '/report/payin', active: true}
            ],
            pageTitle: {i18n: 'sections.report.payin.title', default: 'Payin'}
          }
        },
        {
          path: '/report/receipt',
          name: 'report-receipt',
          component: () => import('./views/pages/Report/Receipt/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.report.title', default: 'report'}},
              {title: {i18n: 'sections.report.receipt.title', default: 'Receipt'}, url: '/report/receipt', active: true}
            ],
            pageTitle: {i18n: 'sections.report.receipt.title', default: 'Receipt'}
          }
        },
        {
          path: '/report/closureNotification',
          name: 'report-closure-notification',
          component: () => import('./views/pages/Report/ClosureNotification/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.report.title', default: 'report'}},
              {
                title: {i18n: 'sections.report.closureNotification.title', default: 'Debt Collection'},
                url: '/report/closureNotification',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.report.closureNotification.title', default: 'Closure Notification'}
          }
        },
        {
          path: '/report/debtCollection',
          name: 'report-debt-collection',
          component: () => import('./views/pages/Report/DebtCollection/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.report.title', default: 'report'}},
              {
                title: {i18n: 'sections.report.debtCollection.title', default: 'Debt Collection'},
                url: '/report/debtCollection',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.report.debtCollection.title', default: 'Debt Collection'}
          }
        },
        {
          path: '/report/excel',
          name: 'report-excel',
          component: () => import('./views/pages/Report/Excel/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.report.title', default: 'report'}},
              {title: {i18n: 'sections.report.excel.title', default: 'Excel'}, url: '/report/excel', active: true}
            ],
            pageTitle: {i18n: 'sections.report.excel.title', default: 'Excel'}
          }
        },
        // =============================================================================
        // Theme Master
        // =============================================================================
        {
          path: '/master/period',
          name: 'master-period',
          component: () => import('./views/pages/Master/Period/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {title: {i18n: 'sections.master.period.title', default: 'Period'}, url: '/master/period', active: true}
            ],
            pageTitle: {i18n: 'sections.master.period.title', default: 'Period'}
          }
        },
        {
          path: '/master/period/add',
          name: 'master-period-add',
          component: () => import('./views/pages/Master/Period/add.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {title: {i18n: 'sections.master.period.title', default: 'Period'}, url: '/master/period', active: true},
              {
                title: {i18n: 'sections.master.period.add.title', default: 'Add'},
                url: '/master/period/add',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.period.add.title', default: 'Add'}
          }
        },
        {
          path: '/master/period/edit/:id',
          name: 'master-period-edit',
          component: () => import('./views/pages/Master/Period/edit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {title: {i18n: 'sections.master.period.title', default: 'Period'}, url: '/master/period', active: true},
              {
                title: {i18n: 'sections.master.period.edit.title', default: 'Edit'},
                url: '/master/period/edit/:id',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.period.edit.title', default: 'Edit'}
          }
        },
        {
          path: '/master/degree',
          name: 'master-degree',
          component: () => import('./views/pages/Master/Degree/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {title: {i18n: 'sections.master.degree.title', default: 'Degree'}, url: '/master/degree', active: true}
            ],
            pageTitle: {i18n: 'sections.master.degree.title', default: 'Degree'}
          }
        },
        {
          path: '/master/degree/add',
          name: 'master-degree-add',
          component: () => import('./views/pages/Master/Degree/add.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {title: {i18n: 'sections.master.degree.title', default: 'Degree'}, url: '/master/degree', active: true},
              {
                title: {i18n: 'sections.master.degree.add.title', default: 'Add'},
                url: '/master/degree/add',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.degree.add.title', default: 'Add'}
          }
        },
        {
          path: '/master/degree/edit/:id',
          name: 'master-degree-edit',
          component: () => import('./views/pages/Master/Degree/edit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {title: {i18n: 'sections.master.degree.title', default: 'Degree'}, url: '/master/degree', active: true},
              {
                title: {i18n: 'sections.master.degree.edit.title', default: 'Edit'},
                url: '/master/degree/edit/:id',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.degree.edit.title', default: 'Edit'}
          }
        },
        {
          path: '/master/project',
          name: 'master-project',
          component: () => import('./views/pages/Master/Project/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {title: {i18n: 'sections.master.project.title', default: 'Project'}, url: '/master/project', active: true}
            ],
            pageTitle: {i18n: 'sections.master.project.title', default: 'Project'}
          }
        },
        {
          path: '/master/project/add',
          name: 'master-project-add',
          component: () => import('./views/pages/Master/Project/add.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {
                title: {i18n: 'sections.master.project.title', default: 'Project'},
                url: '/master/project',
                active: true
              },
              {
                title: {i18n: 'sections.master.project.add.title', default: 'Add'},
                url: '/master/project/add',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.project.add.title', default: 'Add'}
          }
        },
        {
          path: '/master/project/edit/:id',
          name: 'master-project-edit',
          component: () => import('./views/pages/Master/Project/edit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {
                title: {i18n: 'sections.master.project.title', default: 'Project'},
                url: '/master/project',
                active: true
              },
              {
                title: {i18n: 'sections.master.project.edit.title', default: 'Edit'},
                url: '/master/project/edit/:id',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.project.edit.title', default: 'Edit'}
          }
        },
        {
          path: '/master/campus',
          name: 'master-campus',
          component: () => import('./views/pages/Master/Campus/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {title: {i18n: 'sections.master.campus.title', default: 'Campus'}, url: '/master/campus', active: true}
            ],
            pageTitle: {i18n: 'sections.master.campus.title', default: 'Campus'}
          }
        },
        {
          path: '/master/campus/add',
          name: 'master-campus-add',
          component: () => import('./views/pages/Master/Campus/add.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {title: {i18n: 'sections.master.campus.title', default: 'Campus'}, url: '/master/campus', active: true},
              {
                title: {i18n: 'sections.master.campus.add.title', default: 'Add'},
                url: '/master/campus/add',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.campus.add.title', default: 'Add'}
          }
        },
        {
          path: '/master/campus/edit/:id',
          name: 'master-campus-edit',
          component: () => import('./views/pages/Master/Campus/edit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {title: {i18n: 'sections.master.campus.title', default: 'Campus'}, url: '/master/campus', active: true},
              {
                title: {i18n: 'sections.master.campus.edit.title', default: 'Edit'},
                url: '/master/campus/edit/:id',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.campus.edit.title', default: 'Edit'}
          }
        },
        {
          path: '/master/curriculum',
          name: 'master-curriculum',
          component: () => import('./views/pages/Master/Curriculum/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {
                title: {i18n: 'sections.master.curriculum.title', default: 'Curriculum'},
                url: '/master/curriculum',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.curriculum.title', default: 'Curriculum'}
          }
        },
        {
          path: '/master/curriculum/add',
          name: 'master-curriculum-add',
          component: () => import('./views/pages/Master/Curriculum/add.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {
                title: {i18n: 'sections.master.curriculum.title', default: 'Curriculum'},
                url: '/master/curriculum',
                active: true
              },
              {
                title: {i18n: 'sections.master.curriculum.add.title', default: 'Add'},
                url: '/master/curriculum/add',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.curriculum.add.title', default: 'Add'}
          }
        },
        {
          path: '/master/curriculum/edit/:id',
          name: 'master-curriculum-edit',
          component: () => import('./views/pages/Master/Curriculum/edit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {
                title: {i18n: 'sections.master.curriculum.title', default: 'Curriculum'},
                url: '/master/curriculum',
                active: true
              },
              {
                title: {i18n: 'sections.master.curriculum.edit.title', default: 'Edit'},
                url: '/master/curriculum/edit/:id',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.curriculum.edit.title', default: 'Edit'}
          }
        },
        {
          path: '/master/curriculumExternal',
          name: 'master-curriculum-external',
          component: () => import('./views/pages/Master/CurriculumExternal/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {
                title: {i18n: 'sections.master.curriculumExternal.title', default: 'CurriculumExternal'},
                url: '/master/curriculumExternal',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.curriculumExternal.title', default: 'CurriculumExternal'}
          }
        },
        // {
        //   path: '/master/curriculumExternal/add',
        //   name: 'master-curriculum-external-add',
        //   component: () => import('./views/pages/Master/Curriculum/add.vue'),
        //   meta: {
        //     breadcrumb: [
        //       { title: 'Home', url: '/' },
        //       { title: { i18n: 'sections.master.title', default: 'Master' } },
        //       { title: { i18n: 'sections.master.curriculumExternal.title', default: 'Curriculum' }, url: '/master/curriculumExternal', active: true },
        //       { title: { i18n: 'sections.master.curriculumExternal.add.title', default: 'Add' }, url: '/master/curriculumExternal/add', active: true }
        //     ],
        //     pageTitle: { i18n: 'sections.master.curriculumExternal.add.title', default: 'Add' }
        //   }
        // },
        // {
        //   path: '/master/curriculumExternal/edit/:id',
        //   name: 'master-curriculum-external-edit',
        //   component: () => import('./views/pages/Master/Curriculum/edit.vue'),
        //   meta: {
        //     breadcrumb: [
        //       { title: 'Home', url: '/' },
        //       { title: { i18n: 'sections.master.title', default: 'Master' } },
        //       { title: { i18n: 'sections.master.curriculumExternal.title', default: 'Curriculum' }, url: '/master/curriculumExternal', active: true },
        //       { title: { i18n: 'sections.master.curriculumExternal.edit.title', default: 'Edit' }, url: '/master/curriculumExternal/edit/:id', active: true }
        //     ],
        //     pageTitle: { i18n: 'sections.master.curriculumExternal.edit.title', default: 'Edit' }
        //   }
        // },
        {
          path: '/master/faculty',
          name: 'master-faculty',
          component: () => import('./views/pages/Master/Faculty/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {title: {i18n: 'sections.master.faculty.title', default: 'Faculty'}, url: '/master/faculty', active: true}
            ],
            pageTitle: {i18n: 'sections.master.faculty.title', default: 'Faculty'}
          }
        },
        {
          path: '/master/faculty/add',
          name: 'master-faculty-add',
          component: () => import('./views/pages/Master/Faculty/add.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {
                title: {i18n: 'sections.master.faculty.title', default: 'Faculty'},
                url: '/master/faculty',
                active: true
              },
              {
                title: {i18n: 'sections.master.faculty.add.title', default: 'Add'},
                url: '/master/faculty/add',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.faculty.add.title', default: 'Add'}
          }
        },
        {
          path: '/master/faculty/edit/:id',
          name: 'master-faculty-edit',
          component: () => import('./views/pages/Master/Faculty/edit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {
                title: {i18n: 'sections.master.faculty.title', default: 'Faculty'},
                url: '/master/faculty',
                active: true
              },
              {
                title: {i18n: 'sections.master.faculty.edit.title', default: 'Edit'},
                url: '/master/faculty/edit/:id',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.faculty.edit.title', default: 'Edit'}
          }
        },
        {
          path: '/master/prefix',
          name: 'master-prefix',
          component: () => import('./views/pages/Master/Prefix/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {title: {i18n: 'sections.master.prefix.title', default: 'Prefix'}, url: '/master/prefix', active: true}
            ],
            pageTitle: {i18n: 'sections.master.prefix.title', default: 'Prefix'}
          }
        },
        {
          path: '/master/prefix/add',
          name: 'master-prefix-add',
          component: () => import('./views/pages/Master/Prefix/add.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {title: {i18n: 'sections.master.prefix.title', default: 'Prefix'}, url: '/master/prefix', active: true},
              {
                title: {i18n: 'sections.master.prefix.add.title', default: 'Add'},
                url: '/master/prefix/add',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.prefix.add.title', default: 'Add'}
          }
        },
        {
          path: '/master/prefix/edit/:id',
          name: 'master-prefix-edit',
          component: () => import('./views/pages/Master/Prefix/edit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {title: {i18n: 'sections.master.prefix.title', default: 'Prefix'}, url: '/master/prefix', active: true},
              {
                title: {i18n: 'sections.master.prefix.edit.title', default: 'Edit'},
                url: '/master/prefix/edit/:id',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.prefix.edit.title', default: 'Edit'}
          }
        },
        {
          path: '/master/relationship',
          name: 'master-relationship',
          component: () => import('./views/pages/Master/Relationship/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {
                title: {i18n: 'sections.master.relationship.title', default: 'Relationship'},
                url: '/master/relationship',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.relationship.title', default: 'Relationship'}
          }
        },
        {
          path: '/master/relationship/add',
          name: 'master-relationship-add',
          component: () => import('./views/pages/Master/Relationship/add.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {
                title: {i18n: 'sections.master.relationship.title', default: 'Relationship'},
                url: '/master/relationship',
                active: true
              },
              {
                title: {i18n: 'sections.master.relationship.add.title', default: 'Add'},
                url: '/master/relationship/add',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.relationship.add.title', default: 'Add'}
          }
        },
        {
          path: '/master/relationship/edit/:id',
          name: 'master-relationship-edit',
          component: () => import('./views/pages/Master/Relationship/edit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {
                title: {i18n: 'sections.master.relationship.title', default: 'Relationship'},
                url: '/master/relationship',
                active: true
              },
              {
                title: {i18n: 'sections.master.relationship.edit.title', default: 'Edit'},
                url: '/master/relationship/edit/:id',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.relationship.edit.title', default: 'Edit'}
          }
        },
        {
          path: '/master/nationality',
          name: 'master-nationality',
          component: () => import('./views/pages/Master/Nationality/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {
                title: {i18n: 'sections.master.nationality.title', default: 'Nationality'},
                url: '/master/nationality',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.nationality.title', default: 'Nationality'}
          }
        },
        {
          path: '/master/nationality/add',
          name: 'master-nationality-add',
          component: () => import('./views/pages/Master/Nationality/add.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {
                title: {i18n: 'sections.master.nationality.title', default: 'Nationality'},
                url: '/master/nationality',
                active: true
              },
              {
                title: {i18n: 'sections.master.nationality.add.title', default: 'Add'},
                url: '/master/nationality/add',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.nationality.add.title', default: 'Add'}
          }
        },
        {
          path: '/master/nationality/edit/:id',
          name: 'master-nationality-edit',
          component: () => import('./views/pages/Master/Nationality/edit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {
                title: {i18n: 'sections.master.nationality.title', default: 'Nationality'},
                url: '/master/nationality',
                active: true
              },
              {
                title: {i18n: 'sections.master.nationality.edit.title', default: 'Edit'},
                url: '/master/nationality/edit/:id',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.nationality.edit.title', default: 'Edit'}
          }
        },
        {
          path: '/master/race',
          name: 'master-race',
          component: () => import('./views/pages/Master/Race/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {title: {i18n: 'sections.master.race.title', default: 'Race'}, url: '/master/race', active: true}
            ],
            pageTitle: {i18n: 'sections.master.race.title', default: 'Race'}
          }
        },
        {
          path: '/master/race/add',
          name: 'master-race-add',
          component: () => import('./views/pages/Master/Race/add.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {title: {i18n: 'sections.master.race.title', default: 'Race'}, url: '/master/race', active: true},
              {title: {i18n: 'sections.master.race.add.title', default: 'Add'}, url: '/master/race/add', active: true}
            ],
            pageTitle: {i18n: 'sections.master.race.add.title', default: 'Add'}
          }
        },
        {
          path: '/master/race/edit/:id',
          name: 'master-race-edit',
          component: () => import('./views/pages/Master/Race/edit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {title: {i18n: 'sections.master.race.title', default: 'Race'}, url: '/master/race', active: true},
              {
                title: {i18n: 'sections.master.race.edit.title', default: 'Edit'},
                url: '/master/race/edit/:id',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.race.edit.title', default: 'Edit'}
          }
        },
        {
          path: '/master/religion',
          name: 'master-religion',
          component: () => import('./views/pages/Master/Religion/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {
                title: {i18n: 'sections.master.religion.title', default: 'Religion'},
                url: '/master/religion',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.religion.title', default: 'Religion'}
          }
        },
        {
          path: '/master/religion/add',
          name: 'master-religion-add',
          component: () => import('./views/pages/Master/Religion/add.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {
                title: {i18n: 'sections.master.religion.title', default: 'Religion'},
                url: '/master/religion',
                active: true
              },
              {
                title: {i18n: 'sections.master.religion.add.title', default: 'Add'},
                url: '/master/religion/add',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.religion.add.title', default: 'Add'}
          }
        },
        {
          path: '/master/religion/edit/:id',
          name: 'master-religion-edit',
          component: () => import('./views/pages/Master/Religion/edit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {
                title: {i18n: 'sections.master.religion.title', default: 'Religion'},
                url: '/master/religion',
                active: true
              },
              {
                title: {i18n: 'sections.master.religion.edit.title', default: 'Edit'},
                url: '/master/religion/edit/:id',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.religion.edit.title', default: 'Edit'}
          }
        },
        {
          path: '/master/occupation',
          name: 'master-occupation',
          component: () => import('./views/pages/Master/Occupation/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {
                title: {i18n: 'sections.master.occupation.title', default: 'Occupation'},
                url: '/master/occupation',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.occupation.title', default: 'Occupation'}
          }
        },
        {
          path: '/master/occupation/add',
          name: 'master-occupation-add',
          component: () => import('./views/pages/Master/Occupation/add.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {
                title: {i18n: 'sections.master.occupation.title', default: 'Occupation'},
                url: '/master/occupation',
                active: true
              },
              {
                title: {i18n: 'sections.master.occupation.add.title', default: 'Add'},
                url: '/master/occupation/add',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.occupation.add.title', default: 'Add'}
          }
        },
        {
          path: '/master/occupation/edit/:id',
          name: 'master-occupation-edit',
          component: () => import('./views/pages/Master/Occupation/edit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {
                title: {i18n: 'sections.master.occupation.title', default: 'Occupation'},
                url: '/master/occupation',
                active: true
              },
              {
                title: {i18n: 'sections.master.occupation.edit.title', default: 'Edit'},
                url: '/master/occupation/edit/:id',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.occupation.edit.title', default: 'Edit'}
          }
        },
        {
          path: '/master/signer',
          name: 'master-signer',
          component: () => import('./views/pages/Master/Signer/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {title: {i18n: 'sections.master.signer.title', default: 'Signer'}, url: '/master/signer', active: true}
            ],
            pageTitle: {i18n: 'sections.master.signer.title', default: 'Signer'}
          }
        },
        {
          path: '/master/signer/add',
          name: 'master-signer-add',
          component: () => import('./views/pages/Master/Signer/add.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {title: {i18n: 'sections.master.signer.title', default: 'Signer'}, url: '/master/signer', active: true},
              {
                title: {i18n: 'sections.master.signer.add.title', default: 'Add'},
                url: '/master/signer/add',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.signer.add.title', default: 'Add'}
          }
        },
        {
          path: '/master/signer/edit/:id',
          name: 'master-signer-edit',
          component: () => import('./views/pages/Master/Signer/edit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {title: {i18n: 'sections.master.signer.title', default: 'Signer'}, url: '/master/signer', active: true},
              {
                title: {i18n: 'sections.master.signer.edit.title', default: 'Edit'},
                url: '/master/signer/edit/:id',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.signer.edit.title', default: 'Edit'}
          }
        },
        {
          path: '/master/notificationTemplate',
          name: 'master-notificationTemplate',
          component: () => import('./views/pages/Master/NotificationTemplate/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {
                title: {i18n: 'sections.master.notificationTemplate.title', default: 'NotificationTemplate'},
                url: '/master/notificationTemplate',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.notificationTemplate.title', default: 'NotificationTemplate'}
          }
        },
        {
          path: '/master/notificationTemplate/add',
          name: 'master-notificationTemplate-add',
          component: () => import('./views/pages/Master/NotificationTemplate/add.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {
                title: {i18n: 'sections.master.notificationTemplate.title', default: 'NotificationTemplate'},
                url: '/master/notificationTemplate',
                active: true
              },
              {
                title: {i18n: 'sections.master.notificationTemplate.add.title', default: 'Add'},
                url: '/master/notificationTemplate/add',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.notificationTemplate.add.title', default: 'Add'}
          }
        },
        {
          path: '/master/notificationTemplate/edit/:id',
          name: 'master-notificationTemplate-edit',
          component: () => import('./views/pages/Master/NotificationTemplate/edit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {
                title: {i18n: 'sections.master.notificationTemplate.title', default: 'NotificationTemplate'},
                url: '/master/notificationTemplate',
                active: true
              },
              {
                title: {i18n: 'sections.master.notificationTemplate.edit.title', default: 'Edit'},
                url: '/master/notificationTemplate/edit/:id',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.notificationTemplate.edit.title', default: 'Edit'}
          }
        },
        {
          path: '/master/debt-restructure-policy',
          name: 'master-debt-restructure-policy',
          component: () => import('./views/pages/Master/DebtRestructurePolicy/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {
                title: {i18n: 'sections.master.debtRestructurePolicy.title', default: 'Debt Restructure Policy'},
                url: '/master/debt-restructure-policy',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.debtRestructurePolicy.title', default: 'Debt Restructure Policy'}
          }
        },
        {
          path: '/master/debt-restructure-policy/add',
          name: 'master-debt-restructure-policy-add',
          component: () => import('./views/pages/Master/DebtRestructurePolicy/addEdit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {
                title: {i18n: 'sections.master.debtRestructurePolicy.title', default: 'Debt Restructure Policy'},
                url: '/master/debt-restructure-policy',
                active: true
              },
              {
                title: {i18n: 'sections.master.debtRestructurePolicy.add.title', default: 'Add'},
                url: '/master/debt-restructure-policy/add',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.debtRestructurePolicy.add.title', default: 'Add'}
          }
        },
        {
          path: '/master/debt-restructure-policy/edit/:id',
          name: 'master-debt-restructure-policy-edit',
          component: () => import('./views/pages/Master/DebtRestructurePolicy/addEdit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.master.title', default: 'Master'}},
              {
                title: {i18n: 'sections.master.debtRestructurePolicy.title', default: 'Debt Restructure Policy'},
                url: '/master/debt-restructure-policy',
                active: true
              },
              {
                title: {i18n: 'sections.master.debtRestructurePolicy.edit.title', default: 'Edit'},
                url: '/master/debt-restructure-policy/edit/:id',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.master.debtRestructurePolicy.edit.title', default: 'Edit'}
          }
        },


        // =============================================================================
        // Theme System
        // =============================================================================
        {
          path: '/system/eventLog',
          name: 'system-eventLog',
          component: () => import('./views/pages/System/EventLog/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.system.title', default: 'System'}},
              {
                title: {i18n: 'sections.system.eventLog.title', default: 'Event Log'},
                url: '/system/eventLog',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.system.eventLog.title', default: 'Event Log'}
          }
        },
        {
          path: '/system/loginLog',
          name: 'system-loginLog',
          component: () => import('./views/pages/System/LoginLog/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.system.title', default: 'System'}},
              {
                title: {i18n: 'sections.system.loginLog.title', default: 'Login Log'},
                url: '/system/loginLog',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.system.loginLog.title', default: 'Login Log'}
          }
        },
        {
          path: '/system/transactionLog',
          name: 'system-transactionLog',
          component: () => import('./views/pages/System/TransactionLog/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.system.title', default: 'System'}},
              {
                title: {i18n: 'sections.system.transactionLog.title', default: 'Transaction Log'},
                url: '/system/transactionLog',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.system.transactionLog.title', default: 'Transaction Log'}
          }
        },
        {
          path: '/system/importLog',
          name: 'system-importLog',
          component: () => import('./views/pages/System/ImportLog/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.system.title', default: 'System'}},
              {
                title: {i18n: 'sections.system.importLog.title', default: 'Import Log'},
                url: '/system/importLog',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.system.importLog.title', default: 'Import Log'}
          }
        },
        {
          path: '/system/menu',
          name: 'system-menu',
          component: () => import('./views/pages/System/Menu/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.system.title', default: 'System'}},
              {title: {i18n: 'sections.system.menu.title', default: 'Menu'}, url: '/system/menu', active: true}
            ],
            pageTitle: {i18n: 'sections.system.menu.title', default: 'Menu'}
          }
        },
        {
          path: '/system/menu/submenu/:id',
          name: 'system-menu-submenu',
          component: () => import('./views/pages/System/Menu/submenu.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.system.title', default: 'System'}},
              {title: {i18n: 'sections.system.menu.title', default: 'Menu'}, url: '/system/menu', active: true},
              {
                title: {i18n: 'sections.system.menu.submenu.title', default: 'Submenu'},
                url: '/system/menu/submenu',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.system.menu.submenu.title', default: 'Submenu'}
          }
        },
        {
          path: '/system/role',
          name: 'system-role',
          component: () => import('./views/pages/System/Role/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.system.title', default: 'System'}},
              {title: {i18n: 'sections.system.role.title', default: 'Role'}, url: '/system/role', active: true}
            ],
            pageTitle: {i18n: 'sections.system.role.title', default: 'Role'}
          }
        },
        {
          path: '/system/role/add',
          name: 'system-role-add',
          component: () => import('./views/pages/System/Role/add.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.system.title', default: 'System'}},
              {title: {i18n: 'sections.system.role.title', default: 'Role'}, url: '/system/role', active: true},
              {title: {i18n: 'sections.system.role.add.title', default: 'Add'}, url: '/system/role/add', active: true}
            ],
            pageTitle: {i18n: 'sections.system.role.add.title', default: 'Add'}
          }
        },
        {
          path: '/system/role/edit/:id',
          name: 'system-role-edit',
          component: () => import('./views/pages/System/Role/edit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.system.title', default: 'System'}},
              {title: {i18n: 'sections.system.role.title', default: 'Role'}, url: '/system/role', active: true},
              {
                title: {i18n: 'sections.system.role.edit.title', default: 'Edit'},
                url: '/system/role/edit/:id',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.system.role.edit.title', default: 'Edit'}
          }
        },
        {
          path: '/system/config',
          name: 'system-config',
          component: () => import('./views/pages/System/Config/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.system.title', default: 'System'}},
              {title: {i18n: 'sections.system.config.title', default: 'Role'}, url: '/system/config', active: true}
            ],
            pageTitle: {i18n: 'sections.system.config.title', default: 'Role'}
          }
        },
        {
          path: '/system/administrator',
          name: 'system-administrator',
          component: () => import('./views/pages/System/Administrator/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.system.title', default: 'System'}},
              {
                title: {i18n: 'sections.system.administrator.title', default: 'Role'},
                url: '/system/administrator',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.system.administrator.title', default: 'Role'}
          }
        },
        {
          path: '/system/generateQrCode',
          name: 'system-generateQrCode',
          component: () => import('./views/pages/System/GenerateQrCode/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.system.title', default: 'System'}},
              {
                title: {i18n: 'sections.system.generateQrCode.title', default: 'Role'},
                url: '/system/generateQrCode',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.system.generateQrCode.title', default: 'Role'}
          }
        },
        // =============================================================================
        // Theme User
        // =============================================================================
        {
          path: '/user/admin',
          name: 'user-admin',
          component: () => import('./views/pages/User/Admin/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.user.title', default: 'User'}},
              {title: {i18n: 'sections.user.admin.title', default: 'Admin'}, url: '/user/admin', active: true}
            ],
            pageTitle: {i18n: 'sections.user.admin.title', default: 'Admin'}
          }
        },
        {
          path: '/user/admin/add',
          name: 'user-admin-add',
          component: () => import('./views/pages/User/Admin/add.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.user.title', default: 'User'}},
              {title: {i18n: 'sections.user.admin.title', default: 'Admin'}, url: '/user/admin', active: true},
              {title: {i18n: 'sections.user.admin.add.title', default: 'Add'}, url: '/user/admin/add', active: true}
            ],
            pageTitle: {i18n: 'sections.user.admin.add.title', default: 'Add'}
          }
        },
        {
          path: '/user/admin/edit/:id',
          name: 'user-admin-edit',
          component: () => import('./views/pages/User/Admin/edit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.user.title', default: 'User'}},
              {title: {i18n: 'sections.user.admin.title', default: 'Admin'}, url: '/user/admin', active: true},
              {
                title: {i18n: 'sections.user.admin.edit.title', default: 'Edit'},
                url: '/user/admin/edit/:id',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.user.admin.edit.title', default: 'Edit'}
          }
        },
        {
          path: '/user/student',
          name: 'user-student',
          component: () => import('./views/pages/User/Student/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.user.title', default: 'User'}},
              {title: {i18n: 'sections.user.student.title', default: 'Admin'}, url: '/user/student', active: true}
            ],
            pageTitle: {i18n: 'sections.user.student.title', default: 'Admin'}
          }
        },
        {
          path: '/user/student/edit/:id',
          name: 'user-student-edit',
          component: () => import('./views/pages/User/Student/edit.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.user.title', default: 'User'}},
              {title: {i18n: 'sections.user.student.title', default: 'Admin'}, url: '/user/student', active: true},
              {
                title: {i18n: 'sections.user.student.edit.title', default: 'Edit'},
                url: '/user/student/edit/:id',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.user.student.edit.title', default: 'Edit'}
          }
        },
        // =============================================================================
        // Theme Custom
        // =============================================================================
        {
          path: '/redir/:page/:action',
          name: 'redir',
          component: () => import('./views/pages/Redir.vue'),
        },
        {
          path: '/redir/:page/:action/:userId',
          name: 'redir-by-userId',
          component: () => import('./views/pages/Redir.vue'),
        },
        {
          path: '/notification/list/:action',
          name: 'notification-list',
          component: () => import('./views/pages/Notification/Notification/list.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.home.title', default: 'Home'}},
              {title: {i18n: 'sections.home.list.title', default: 'List'}, url: '/notification', active: true},
            ],
            pageTitle: {i18n: 'sections.home.list.title', default: 'List'}
          }
        },
        {
          path: '/notificationCall/list/:action',
          name: 'notification-call-list',
          component: () => import('./views/pages/Notification/NotificationCall/list.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.home.title', default: 'Home'}},
              {title: {i18n: 'sections.home.list.title', default: 'List'}, url: '/notification', active: true},
            ],
            pageTitle: {i18n: 'sections.home.list.title', default: 'List'}
          }
        },
        {
          path: '/notificationCallEx/list/:action/:userId',
          name: 'notification-call-ex-list',
          component: () => import('./views/pages/Notification/NotificationCallEx/list.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.home.title', default: 'Home'}},
              {title: {i18n: 'sections.home.list.title', default: 'List'}, url: '/notification', active: true},
            ],
            pageTitle: {i18n: 'sections.home.list.title', default: 'List'}
          }
        },
        {
          path: '/notificationPaymentSchedule/list/:action',
          name: 'notification-payment-schedule-list',
          component: () => import('./views/pages/Notification/NotificationPaymentSchedule/list.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.home.title', default: 'Home'}},
              {title: {i18n: 'sections.home.list.title', default: 'List'}, url: '/notification', active: true},
            ],
            pageTitle: {i18n: 'sections.home.list.title', default: 'List'}
          }
        },
        {
          path: '/notificationSale/list/:action',
          name: 'notification-sale-list',
          component: () => import('./views/pages/Notification/NotificationSale/list.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.home.title', default: 'Home'}},
              {title: {i18n: 'sections.home.list.title', default: 'List'}, url: '/notification', active: true},
            ],
            pageTitle: {i18n: 'sections.home.list.title', default: 'List'}
          }
        },
        {
          path: '/notificationSale/detail/:id',
          name: 'notification-sale-detail',
          component: () => import('./views/pages/Notification/NotificationSale/detail.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: {i18n: 'sections.home.title', default: 'Home'}},
              {title: {i18n: 'sections.home.list.title', default: 'List'}, url: '/detail', active: true},
            ],
            pageTitle: {i18n: 'sections.home.list.title', default: 'List'}
          }
        },
        {
          path: '/InstallmentCalculation',
          name: 'Installment-calculation',
          component: () => import('./views/pages/HeaderMenu/InstallmentCalculation/index.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {
                title: {i18n: 'sections.headerMenu.InstallmentCalculation.title', default: 'Role'},
                url: '/InstallmentCalculation',
                active: true
              }
            ],
            pageTitle: {i18n: 'sections.headerMenu.InstallmentCalculation.title', default: 'Role'}
          }
        },
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/auth',
          name: 'user',
          component: () => import('@/views/pages/Auth/index.vue'),
          redirect: '/auth/login',
          children: [
            {
              path: 'login',
              name: 'user-login',
              component: () => import('@/views/pages/Auth/Login.vue')
            },
            {
              path: 'loginWithToken/:token/',
              name: 'user-login-with-token',
              component: () => import('@/views/pages/Auth/LoginWithToken.vue')
            },
            {
              path: 'reset-password',
              name: 'user-reset-password',
              component: () => import('@/views/pages/Auth/ResetPassword.vue'),
              beforeEnter: AuthRequired
            }
          ]
        },
        {
          path: '/pages/not-authorized',
          name: 'page-not-authorized',
          component: () => import('@/views/pages/NotAuthorized.vue')
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },
        {
          path: '/resetKey/:resetKey',
          name: 'resetKey',
          component: () => import('@/views/pages/ResetKey.vue')
        },
        {
          path: '/messengerBorrowerUpload/:id/:token',
          name: 'messenger-borrower-upload',
          component: () => import('@/views/pages/MessengerBorrowerUpload.vue')
        },
        {
          path: '/messengerSuretyUpload/:id/:token',
          name: 'messenger-surety-upload',
          component: () => import('@/views/pages/MessengerSuretyUpload.vue')
        },     // add.vue
        {
          path: 'external/customer/borrower/list',
          name: 'external-customer-borrower-list',
          component: () => import('./views/pages/External/Customer/Borrower/list.vue'),
        },
        {
          path: 'external/customer/borrower/add',
          name: 'external-customer-borrower-add',
          component: () => import('./views/pages/External/Customer/Borrower/add.vue'),
        },
        {
          path: 'external/customer/borrower/edit',
          name: 'external-customer-borrower-edit',
          component: () => import('./views/pages/External/Customer/Borrower/edit.vue'),
        },
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})
router.beforeEach(async (from, to, next) => {
  //reload if not the same version as server
  const correctVersion = await checkServerVersion();
  if (correctVersion) {
    next();
  } else {
    scheduleVersionReload();
  }
});
export default router
